
<transition name="slide-fade">
    <div v-if="visible" class="bounced-mail">
        <div class="bounced-mail-title primary white--text mb-1 v-flex">
            <div class="ml-4">
                {{ title }}
            </div>
            <v-spacer />
            <div class="v-flex">
                <div class="v-flex white pl-2 pr-1 mr-4  bounced-mail-commit">
                    <div class="primary--text">
                        Mail bestätigt
                    </div>
                    <div>
                        <v-checkbox
                            v-model       = "mail.confirmed"
                            class         = "ma-0 pa-0 mr-n2"
                            :ripple       = "false"
                            :hide-details = "true"
                            @click.native.capture = "onClickConfirmed"
                            @change               = "onConfirmed"
                            dense
                        />
                    </div>
                </div>

                <c-toolbar-button
                    :ripple = "false"
                    v-if    = "mail.incidentId"
                    icon    ="mdi-arrow-right-thin-circle-outline"
                    color   ="white"
                    size    = "22"
                    tooltip = "Zum Ereignis wechseln"
                    @click  = "onGoto"
                />

                <c-toolbar-button
                    :ripple = "false"
                    icon    ="mdi-close"
                    color   ="white"
                    size    = "22"
                    tooltip = "Mail schliessen"
                    @click  = "onClose"
                />
            </div>
        </div>

        <div class="lm-border bounced-mail-header pa-3 w-100 h-100">
            <div class="mail-addr">
                <div class="label primary white--text">Von</div>
                <div class="data mail-receiver"> {{ mail.sender }}</div>
            </div>
            <div class="mail-addr">
                <div class="label primary white--text">Empfänger</div>
                <div class="data mail-receiver"> {{ mail.receiver }}</div>
            </div>
            <div class="mail-addr">
                <div class="label primary white--text">Betreff</div>
                <div class="mail-subject">{{ mail.subject }}</div>
            </div>
        </div>

        <div class  = "lm-border bounced-mail-body mt-2 pa-3" :style="heightStyle">
            <div v-html="body">
            </div>
        </div>
    </div>
</transition>
